import { useCallback, useEffect, useState } from "react";
import { getPeriods, getProgress, getSession } from "../service";

// Sessão do aluno + período e progresso nos 4 simulados.
export default function useStudent() {
  const [user] = useState(() => getSession());
  const [progress, setProgress] = useState({});
  const [periods, setPeriods] = useState({});
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    const [nextPeriods, nextProgress] = await Promise.all([getPeriods(), user ? getProgress() : {}]);
    setPeriods(nextPeriods);
    setProgress(nextProgress);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { user, progress, setProgress, periods, loading, reload };
}
